import { ZoteroRepository } from './repository'

export default {
  async FETCH_URL ({ commit }, payload) {
    const fetchedUrl = await ZoteroRepository.fetchURL(payload)
    return fetchedUrl
  }
}
